"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var form_store_1 = __importDefault(require("../stores/form_store"));
var input_actions_1 = __importDefault(require("../actions/input_actions"));
;
;
var BirthStatusOptionalText = /** @class */ (function (_super) {
    __extends(BirthStatusOptionalText, _super);
    function BirthStatusOptionalText(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: "",
            error: []
        };
        _this._isMounted = false;
        form_store_1.default.on('STATE_CHANGE', function () {
            var _a = _this.props, number = _a.number, optNum = _a.optNum;
            if (_this._isMounted) {
                var state = form_store_1.default.getState();
                _this.setState({
                    value: state.data["birth_status_optional_text_".concat(number)] || [],
                    error: state.error["birth_status_optional_text_".concat(number)] || []
                });
            }
        });
        return _this;
    }
    BirthStatusOptionalText.prototype.componentDidMount = function () {
        this._isMounted = true;
        var _a = this.props, number = _a.number, optNum = _a.optNum;
        var state = form_store_1.default.getState();
        this.setState({
            value: state.data["birth_status_optional_text_".concat(number)] || [],
            error: state.error["birth_status_optional_text_".concat(number)] || []
        });
    };
    BirthStatusOptionalText.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    BirthStatusOptionalText.prototype.render = function () {
        var _a = this.props, number = _a.number, optNum = _a.optNum;
        var _b = this.state, value = _b.value, error = _b.error;
        var errorElem = (react_1.default.createElement(react_1.default.Fragment, null));
        if (error.length > 0) {
            errorElem = (react_1.default.createElement("p", { className: "form-error" }, error[0]));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            errorElem,
            react_1.default.createElement("div", { className: "input-set" },
                react_1.default.createElement("input", { className: "input-text input-set__s", type: "text", name: "birth_status_optional_text_".concat(number), value: value, onChange: input_actions_1.default.changeInput, onBlur: input_actions_1.default.changeInput, placeholder: "\u305D\u306E\u4ED6\u306E\u5185\u5BB9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044" }))));
    };
    return BirthStatusOptionalText;
}(react_1.Component));
exports.default = BirthStatusOptionalText;
